import { FileText, Trash2 } from "lucide-react";
import { DEALERSHIP_OPTIONS } from "../../../../Utils/staticDropdownOptions";

function formatFileSize(bytes) {
  if (!bytes && bytes !== 0) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export default function LogisticsSidebar({ form }) {
  const { formData, setFormData, register, validationErrors } = form;

  const tdsFile = formData.technicalDataSheet;
  const existingTds = formData.existingTechnicalDataSheet;

  return (
    <section className="pf-card">
      <h3 className="pf-section-title mb-5">Logistics</h3>

      <div className="space-y-4">
        <div>
          <label className="pf-label">Default Currency</label>
          <select
            {...register("currency")}
            className={`pf-select ${
              validationErrors?.currency ? "is-error" : ""
            }`}
          >
            <option value="">Select Currency (defaults to PKR)</option>
            <option value="PKR">PKR</option>
            <option value="$">$</option>
          </select>
          {validationErrors?.currency && (
            <p className="text-red-500 text-xs mt-1 font-semibold">
              {validationErrors.currency}
            </p>
          )}
        </div>

        <div>
          <label className="pf-label">Dealership Type</label>
          <select
            name="dealership"
            value={formData.dealership}
            onChange={(e) => {
              const match = DEALERSHIP_OPTIONS.find(
                (o) => o.en === e.target.value,
              );
              setFormData((prev) => ({
                ...prev,
                dealership: e.target.value,
                dealership_ur: match?.ur || prev.dealership_ur,
              }));
            }}
            className="pf-select"
          >
            {DEALERSHIP_OPTIONS.map((o) => (
              <option key={o.en} value={o.en}>
                {o.enLabel}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label
            className="pf-label !normal-case tracking-normal text-right"
            dir="rtl"
          >
            ڈیلرشپ کی قسم
          </label>
          <select
            name="dealership_ur"
            value={formData.dealership_ur}
            onChange={(e) => {
              const match = DEALERSHIP_OPTIONS.find(
                (o) => o.ur === e.target.value,
              );
              setFormData((prev) => ({
                ...prev,
                dealership_ur: e.target.value,
                dealership: match?.en || prev.dealership,
              }));
            }}
            dir="rtl"
            className="pf-select text-right font-semibold"
          >
            <option value="">منتخب کریں...</option>
            {DEALERSHIP_OPTIONS.map((o) => (
              <option key={o.ur} value={o.ur}>
                {o.ur}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="pf-label">Technical Data Sheet (TDS)</label>
          <label className="pf-upload-slot block cursor-pointer py-5">
            <FileText size={22} strokeWidth={1.5} />
            <span>Upload TDS (PDF)</span>
            <span className="text-[10px] font-normal text-gray-400">
              Max file size 10MB
            </span>
            <input
              type="file"
              name="technicalDataSheet"
              accept=".pdf,application/pdf"
              className="hidden"
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  technicalDataSheet: e.target.files[0] || null,
                }))
              }
            />
          </label>

          {tdsFile ? (
            <div className="mt-2 flex items-center gap-2 rounded border border-[var(--pf-border)] bg-gray-50 px-3 py-2">
              <FileText size={18} className="text-red-600 shrink-0" />
              <div className="min-w-0 flex-1">
                <p className="text-xs font-semibold text-gray-800 truncate">
                  {tdsFile.name}
                </p>
                <p className="text-[10px] text-gray-500">
                  {formatFileSize(tdsFile.size)}
                </p>
              </div>
              <button
                type="button"
                onClick={() =>
                  setFormData((prev) => ({
                    ...prev,
                    technicalDataSheet: null,
                  }))
                }
                className="text-gray-400 hover:text-red-600"
                aria-label="Remove TDS"
              >
                <Trash2 size={15} />
              </button>
            </div>
          ) : existingTds ? (
            <div className="mt-2 flex items-center gap-2 rounded border border-[var(--pf-border)] bg-gray-50 px-3 py-2">
              <FileText size={18} className="text-red-600 shrink-0" />
              <div className="min-w-0 flex-1">
                <a
                  href={existingTds}
                  target="_blank"
                  rel="noreferrer"
                  className="text-xs font-semibold text-gray-800 truncate block hover:underline"
                >
                  {String(existingTds).split("/").pop() || "Current TDS.pdf"}
                </a>
                <p className="text-[10px] text-emerald-600">Existing file</p>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </section>
  );
}
